import { HttpInterceptorFn, HttpErrorResponse } from '@angular/common/http';
import { inject } from '@angular/core';
import { catchError, throwError } from 'rxjs';
import { Router } from '@angular/router';
import { ToastService } from '@core/services/presenters/toast.service';
import { HttpStatus } from '@core/enum/http-status.enum';
import { ERROR_MESSAGES } from '@shared/utils/constants/error-messages.constant';

const BUSINESS_ERROR_STATUSES: number[] = [
    HttpStatus.BAD_REQUEST,
    HttpStatus.CONFLICT,
    HttpStatus.UNPROCESSABLE_ENTITY,
];

export const errorInterceptor: HttpInterceptorFn = (req, next) => {
    const toastService = inject(ToastService);
    const router = inject(Router);

    return next(req).pipe(
        catchError((error: HttpErrorResponse) => {
            if (BUSINESS_ERROR_STATUSES.includes(error.status)) {
                const apiError = error.error;
                const translated = apiError?.code
                    ? ERROR_MESSAGES[apiError.code]
                    : undefined;

                toastService.show(
                    'error',
                    translated?.title ?? 'No se pudo completar la operación',
                    translated?.subtitle ?? apiError?.message,
                );
            }

            if (error.status === HttpStatus.FORBIDDEN) {
                toastService.show(
                    'error',
                    'Acceso Denegado',
                    'No tienes los permisos suficientes para realizar esta acción o acceder a esta sección.',
                );
            }

            if (error.status === HttpStatus.INTERNAL_SERVER_ERROR) {
                toastService.show(
                    'error',
                    'Error Interno',
                    'Ocurrió un error inesperado. Por favor, intenta nuevamente más tarde.',
                );
            }

            return throwError(() => error);
        })
    );
};